module.exports = __webpack_public_path__ + "as.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/as.svg
// module id = 679
// module chunks = 0